module.exports = __webpack_public_path__ + "img/chinesecompany116.608bf6a2.png";